import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'

const PastAuctions = () => {
  const data = useStaticQuery(graphql`
    {
      allBidJsAuctionsArchived(sort: { auctionEndTime: DESC }, limit: 7) {
        edges {
          node {
            auctionEndTime
            auctionId
            auctionTitle
            auctionUuid
            id
            path
            url
          }
        }
      }
    }
  `)

  return (
    <section className='component-past_auctions bg-brand-orange text-white'>
      <div className='max-w-screen-xl mx-auto p-6'>
        <ul className='grid md:grid-cols-2 overflow-hidden mb-10'>
          {data.allBidJsAuctionsArchived.edges.map((auction) => {
            auction = auction.node
            const prettyURL = '../auctions/#!/auctions/' + auction.auctionUuid
            return (
              <li key={auction.auctionId} className='flex gap-x-6 py-3 hover:underline underline-offset-8'>
                <a href={prettyURL}>
                  <span className='sr-only'>{auction.auctionTitle}</span>
                  <span dangerouslySetInnerHTML={{ __html: auction.auctionTitle }} />
                </a>
              </li>
            )
          })}
        </ul>
        <div>
          <a href='../auctions/#!/auctionsArchived' className='button button-info'>
            View all past auctions
          </a>
        </div>
      </div>
    </section>
  )
}

export default PastAuctions
